import { prependRoot } from "../util/prependRoot.js";
import { getApiRoot } from "../store/configureStore.js";
import axios from "axios";

const sportenOpHetWerkApi = {
    save(model){
        const serviceUrl = prependRoot("sportenOpHetWerk", getApiRoot());
        return axios.post(serviceUrl, model
        ,{
            headers:{
                "accept": "application/json"
            }
        });
    }
};

export default sportenOpHetWerkApi;